import Cookies from 'js-cookie'

export const setAuthToken = (user, tokenCallback) => {
  if (!user) {
    console.warn('setUser: no user provided')
    Cookies.remove('userToken')
    Cookies.set('userTokenExpiresAt')
    tokenCallback && tokenCallback(null, null)
    return
  }
  user.getIdTokenResult().then(({ token, expirationTime, claims }) => {
    Cookies.set('userToken', token)
    Cookies.set('userTokenExpiresAt', expirationTime)
    tokenCallback && tokenCallback(token, expirationTime, claims)
  })
}
export const setUser = (user, userCallback) => {
  console.log('setUser:', 'setting user...')
  if (!user) {
    console.warn('setUser: no user provided')
    Cookies.remove('authUser')
    userCallback && userCallback(null)
    return
  }
  const { displayName, email, emailVerified, emailAddress, photoURL } = user
  console.log('setUser: LOGGED IN: ' + email)
  Cookies.set('authUser', { displayName, email, emailVerified, emailAddress, photoURL })
  userCallback && userCallback(user)
}
